import React from 'react';
import { useDialog } from 'src/context/DialogProvider';
//
import AlertDialog from './model/alert-dialog';
import InviteDialog from './model/invite-dialog';
import RibDialog from './model/rib-dialog';
import CarnetDialog from './model/carnet-dialog';
import IssuedCheck from './model/checks/issued-check';
import QuickIssued from './model/checks/quick-issued';
import QuickReceived from './model/checks/quick-received';
import ReceivedCheck from './model/checks/received_check';
import PrintCheck from './model/checks/print-check';
import DueDate from './model/checks/due-date'
import ViewCheck from './model/checks/update-check';
import ViewCheckRecu from './model/checks/update-check-recu';
import CarnetCheckDialog from './model/checks/carnet-check';
import AddLocal from './model/transfers/add-local';
import { AddTransfer } from './model/transfers/add-transfer';
import AddProject from './model/cautions/add-project';
import AddGuarantee from './model/cautions/add-guarantee';
import AddFiles from './model/cautions/add-files';
import MakePayment from './model/info/make-payment';
import PrintTransfer from './model/transfers/print-transfer';


const DialogManager: React.FC = () => {
  const { activeDialog, closeDialog, dialogProps } = useDialog();
  const renderDialogContent = () => {
    switch (activeDialog) {
      case 'SUCCESS_DIALOG':
        return (
          <AlertDialog
            open
            onClose={closeDialog}
            content={dialogProps.message}
            title="Operation Was Successful"
            actionLabel="Proceed"
            icon="icon-park-solid:success"
            iconSize={60}
          />

        );
      case 'ERROR_DIALOG':
        return (
          <AlertDialog
            open
            onClose={closeDialog}
            content={dialogProps.message}
            title="Operation Was Unsuccessful"
            actionLabel="Close"
            icon="ic:twotone-error"
            iconSize={60}
          />
        );
      case 'INVITE_DIALOG':
        return (
          <InviteDialog
            open
            onClose={closeDialog}
          />
        );
      case 'RIB_DIALOG':
        return (
          <RibDialog
            open
            onClose={closeDialog}
            companyId={dialogProps.companyId}
            companyName={dialogProps.companyName}
          />
        );
      case 'CARNET_DIALOG':
        return (
          <CarnetDialog
            open
            onClose={closeDialog}
            company={dialogProps.company}
            ribId={dialogProps.ribId}
            ribRib={dialogProps.ribRib}
          />
        );
      case 'ISSUED_CHECK_DIALOG': {
        return (
          <IssuedCheck
            open
            onClose={closeDialog}
          />
        );
      }
      case 'CARNET_CHECK_DIALOG': {
        return (
          <CarnetCheckDialog
            open
            onClose={closeDialog}
            companyId={dialogProps.companyId}
            ribId={dialogProps.ribId}
            carnetId={dialogProps.carnetId}
          />
        );
      }
      case 'RECEIVED_CHECK_DIALOG': {
        return (
          <ReceivedCheck
            open
            onClose={closeDialog}
          />
        );
      }
      case 'QUICK_ISSUED_CHECK_DIALOG': {
        const { companyId, ribId, carnetId, check, amount } = dialogProps;
        return (
          <QuickIssued
            open
            onClose={closeDialog}
            company={companyId}
            rib={ribId}
            carnet={carnetId}
            check={check}
            amount={amount}
          />
        );
      }
      case 'QUICK_RECEIVED_CHECK_DIALOG': {
        const { companyId, ribId, type, amount } = dialogProps;
        return (
          <QuickReceived
            open
            onClose={closeDialog}
            rib={ribId}
            company={companyId}
            type={type}
            amount={amount}
          />
        );
      }
      case 'ADD_DUE_DATE': {
        const { id, typo, carnet, rib, company } = dialogProps;
        return (
          <DueDate
            open
            onClose={closeDialog}
            id={id}
            typo={typo}
            rib={rib}
            company={company}
            carnet={carnet}
          />
        );
      }
      case 'VIEW_CHECK': {
        const { _id } = dialogProps;
        return (
          <ViewCheck
            open
            onClose={closeDialog}
            check_id={_id}
          />
        );
      }
      case 'VIEW_CHECK_RECU': {
        const { _id } = dialogProps;
        return (
          <ViewCheckRecu
            open
            onClose={closeDialog}
            check_id={_id}
          />
        );
      }
      case 'PRINT_DIALOG':
        return (
          <PrintCheck
            open
            onClose={closeDialog}
            row={dialogProps.row}
          />
        );
      case 'ADD_LOCAL_BENEFICIARY':
        return (
          <AddLocal
            open
            onClose={closeDialog}
            typ={dialogProps.type}
          />
        );
      case 'ADD_TRANSFER':
        return (
          <AddTransfer
            open
            onClose={closeDialog}
          />
        );
      case 'ADD_PROJECT':
        return (
          <AddProject
            open
            onClose={closeDialog}
          />
        );
      case 'ADD_GUARANTEE':
        return (
          <AddGuarantee
            open
            onClose={closeDialog}
            projectId={dialogProps.projectId}
          />
        );
      case 'ADD_FILES':
        return (
          <AddFiles
            open
            onClose={closeDialog}
            cautionId={dialogProps.cautionId}
          />
        );
      case 'MAKE_PAYMENT':
        return (
          <MakePayment
            open
            onClose={closeDialog}
          />
        );
      case 'PRINT_TRANSFER_DIALOG':
        return (
          <PrintTransfer
            open
            onClose={closeDialog}
            row={dialogProps.row}
          />
        );
      default:
        return null;
    }
  };

  return <>{renderDialogContent()}</>;
};

export default DialogManager;
